<template>
  <el-affix :offset="0" style="width: 100%;">
    <Navigation></Navigation>
  </el-affix>
  <router-view />
  <Footer></Footer>

  <el-backtop style="right: 2vw;" :bottom="30" />
</template>

<style lang="scss">
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

nav {
  // padding: 30px;

  a {
    font-weight: bold;
    color: #2c3e50;

    &.router-link-exact-active {
      color: #42b983;
    }
  }
}
</style>
